import {drawCircleFill, drawRectangle, getBoundsForRectAroundCentre, mapMotorToCanvas} from "../utils/map_utils";
import BaseLayer from "./BaseLayer";

class ImageGrid extends BaseLayer {

    id = "imageGrid";
    label = "Image Grid";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {pathUnitMap, deviceSettings, tileFlag, textColor} = this.props;
        let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;
        Object.values(pathUnitMap.scanCellMap).forEach(scanCell => {
            const {xPosition, yPosition} = scanCell.position;
            let {x, y} = mapMotorToCanvas(xPosition, yPosition, this.props.slide,
                {device_settings: deviceSettings});
            if (tileFlag['reverseYTileOrder']['flagY'])
                y = y_fields * tile_height * uperpixel - y;
            x = Math.floor(x / (tile_width * uperpixel));
            y = Math.floor(y / (tile_height * uperpixel));
            if (scanCell.selectedForScan) {
                let bounds = getBoundsForRectAroundCentre(tile_width, tile_height, uperpixel, x, y, 0.5);
                drawRectangle(bounds, this.layer.getSource(), false, 2, "#eaff00", "", textColor);
                drawCircleFill(x, y, 0.01 * tile_height * uperpixel, this.layer.getSource(), "", false,
                    1, "#7CFC00", "", textColor);
                bounds = getBoundsForRectAroundCentre(tile_width, tile_height, uperpixel, x, y, 0.05);
                drawRectangle(bounds, this.layer.getSource(), false, 2, "#eaff00", "", textColor);
            }
            if (scanCell.rescan) {
                let bounds = getBoundsForRectAroundCentre(tile_width, tile_height, uperpixel, x, y, 0.45);
                drawRectangle(bounds, this.layer.getSource(), false, 2, "#eaff00", "", textColor);
            }
        });
        resolve();
    })
}

export default ImageGrid;
